import type { Offer } from '@libs/common-types';

import { cweaClient } from '../clients/api-proxy-browser-client';
import { CWEA_ENDPOINTS } from '../constants';
import { unwrapApiResponseOrThrow } from './utils';

export type EarnedPointsInfo = {
    offer: Offer | null;
    earnedPoints: number | null;
};

export type PointsPayoutResponse = {
    newBadgeDisplay: boolean;
    milestones: number[];
    spendTotal: number;
    pointsEarned: number;
    pointsEarnedPaidOutDate: string;
    spendNeededForNextMilestone: number;
    currentQuarterMaxDate: string;
    incrementalPoints: number;
    maxPoints: number;
    earnedPointsInfo: EarnedPointsInfo;
};

export async function getPointsPayout(): Promise<PointsPayoutResponse> {
    const url = CWEA_ENDPOINTS.pointsPayout.get();

    const response = await cweaClient.get<PointsPayoutResponse>(url);

    return unwrapApiResponseOrThrow(response, 'Failed to fetch points payout info');
}
